import { ACL_TYPE } from '@openx/types/aclType';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext';
import { isAllowedByCompiledAcl } from '@openx/utils/permission/validators';
import { useMemo } from 'react';

export const useShowRboLightweight = (): boolean => {
  const { useIsAllowed } = usePermissionContext();
  const { isAllowed } = useIsAllowed();

  return useMemo(() => isAllowed(isAllowedByCompiledAcl(ACL_TYPE.RESULTS_ENABLED)), [isAllowed]);
};
